<script setup lang="ts">
import type { IProps } from './career-emptyResults.types'
import CareerSearchResults from '~/domains/career/components/career-searchResults/career-searchResults.vue'

defineProps<IProps>()
</script>

<template>
  <div class="Empty-Results">
    <div
      class="Empty-Results__info"
    >
      <img
        src="/icons/empty_search.svg"
        width="96"
        height="96"
        alt="Niestety nie mamy żadnej oferty z podanymi przez Ciebie kryteriami."
      >

      <h2 class="Empty-Results__header">
        Niestety nie mamy żadnej oferty z podanymi przez Ciebie kryteriami.
      </h2>

      <p class="Empty-Results__text">
        Zmień kryteria wyszukiwania i spróbuj ponownie.
      </p>
    </div>

    <div class="Empty-Results__container">
      <CareerSearchResults
        header="Aktualne oferty pracy:"
        text-link="Pokaż więcej wyników"
        :limit="9"
        link="/o-benefit-systems/kariera/wszystkie-oferty"
        :with-wrapper="true"
        :cards="currentOffers"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.Empty-Results {
  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2.4rem;
    max-width: 88rem;
    margin: 0 auto;
    padding: 0 0 4rem;
    text-align: center;

    @include atM {
      padding: 4rem 0 9.6rem;
    }
  }

  &__header {
    @include h9;
    margin-bottom: 1.6rem;

    @include atM {
      @include h6;
    }
  }

  &__text {
    @include body-1;
  }

  &__container {
    padding-top: 4rem;
    border-top: 1px solid $gray-300;

    @include atM {
      padding-top: 9.6rem;
    }
  }
}
</style>
